import Vue from 'vue'
import * as API from '@/endpoints'
import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    userId: '',
    type: '',
    show: false,
    isLoading: false,
    isLoadingMore: false,
    userFollowers: {},
    userFollowing: {},
    page: 1
  },
  mutations: {
    show(state, data) {
      if(state.userId != data.userId || state.type != data.type) {
        Vue.set(state, 'userFollowers', {})
        Vue.set(state, 'userFollowing', {})
      }
      Vue.set(state, 'show', true)
      Vue.set(state, 'userId', data.userId)
      Vue.set(state, 'type', data.type)
      Vue.set(state, 'page', 1)
    },
    hide(state) {
      Vue.set(state, 'show', false)
    },
    setLoader(state, v) {
      Vue.set(state, 'isLoading', v)
    },
    setLoaderMore(state, v) {
      Vue.set(state, 'isLoadingMore', v)
    },
    addUserFollowers(state, v) {
      if(!('subscribers' in state.userFollowers) || v.page == 1) {
        Vue.set(state, 'userFollowers', v)
      } else if(state.userFollowers.subscribers) {
        var userFollowers = state.userFollowers.subscribers

        for(let x = 0; x < v.subscribers.length; x++) {
          userFollowers.subscribers.push(v.subscribers[x])
        }

        Vue.set(state, 'userFollowers', userFollowers)
      }
    },
    addUserFollowing(state, v) {
      if(!('subscribers' in state.userFollowing) || v.page == 1) {
        Vue.set(state, 'userFollowing', v)
      } else if(state.userFollowing.subscribers) {
        var userFollowing = state.userFollowing

        for(let x = 0; x < v.subscribers.length; x++) {
          userFollowing.subscribers.push(v.subscribers[x])
        }

        Vue.set(state, 'userFollowing', userFollowing)
      }
    }
  },
  actions: {
    getUserFollowing({ commit, dispatch, state }, {id}) {
      if( !id ) return false;

      if( state.page == 1) commit('setLoader', true)

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/' + id + '/following?page=' + state.page).then(
          res => {
            commit('setLoader', false)
            commit('setLoaderMore', false)
            commit('addUserFollowing', res.data)
            resolve(res.data)
          },
          error => {
            commit('setLoader', false)
            commit('setLoaderMore', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserFollowers({ commit, dispatch, state }, {id}) {
      if( !id ) return false;

      if( state.page == 1) commit('setLoader', true)

      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.user + '/' + id + '/followers?page=' + state.page).then(
          res => {
            commit('setLoader', false)
            commit('setLoaderMore', false)
            commit('addUserFollowers', res.data)
            resolve(res.data)
          },
          error => {
            commit('setLoader', false)
            commit('setLoaderMore', false)
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },
    getUserFollowingNextPage({commit, dispatch, state}, {id}) {
      Vue.set(state, 'page', state.page + 1)
      commit('setLoaderMore', true)
      dispatch('getUserFollowing', {id: id})
    },
    getUserFollowersNextPage({commit, dispatch, state}, {id}) {
      Vue.set(state, 'page', state.page + 1)
      commit('setLoaderMore', true)
      dispatch('getUserFollowers', {id: id})
    }
  }
}